import { IngredientCategory } from './ingredients';

export interface CategoryTranslation {
  en: string;
  fr: string;
}

export const categoryTranslations: Record<IngredientCategory, CategoryTranslation> = {
  produce: {
    en: 'Produce',
    fr: 'Fruits & Légumes'
  },
  meat: {
    en: 'Meat',
    fr: 'Viande'
  },
  seafood: {
    en: 'Seafood',
    fr: 'Poisson & Fruits de mer'
  },
  deli: {
    en: 'Deli',
    fr: 'Charcuterie'
  },
  dairy: {
    en: 'Dairy',
    fr: 'Produits laitiers'
  },
  sweetGrocery: {
    en: 'Sweet Grocery',
    fr: 'Épicerie sucrée'
  },
  savoryGrocery: {
    en: 'Savory Grocery',
    fr: 'Épicerie salée'
  },
  bakery: {
    en: 'Bakery',
    fr: 'Boulangerie'
  },
  frozen: {
    en: 'Frozen',
    fr: 'Surgelés'
  },
  beverages: {
    en: 'Beverages',
    fr: 'Boissons'
  },
  condiments: {
    en: 'Condiments',
    fr: 'Condiments & Sauces'
  },
  other: {
    en: 'Other',
    fr: 'Autre'
  }
};

/**
 * Get translated category name
 */
export function getCategoryLabel(category: IngredientCategory, language: 'en' | 'fr' = 'fr'): string {
  return categoryTranslations[category]?.[language] || category;
}

